<template>
    <el-drawer title="" :visible.sync="selectFieldDrawer" size="520px" direction="rtl" :before-close="handleSelectFieldClose" :custom-class="'custom-drawer'">
        <template slot="title">
            <span>为 [{{ currentSelectInfo && currentSelectInfo.field }}] 匹配Excel表头字段</span>
        </template>
        <div class="custom-drawer-content">
            <el-button v-for="(item, index) in fieldList" :key="index" :disabled="item.disabled" :class="{ 'active': selectFieldName == item.field }" @click="changeSelectField(item)">
                <el-tooltip class="item" effect="dark" content="该字段已被匹配" placement="top-start" v-if="item.disabled">
                    <span>{{ item.title }}</span>
                </el-tooltip>
                <span v-else>{{ item.title }}</span>
            </el-button>
        </div>
        <div class="custom-drawer-footer">
            <el-button @click="handleSelectFieldClose">取消</el-button>
            <el-button type="primary" @click="handleSelectFieldConfirm">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
            selectFieldDrawer: false,
            selectFieldName: "",
            fieldList: [
                { title: '姓名', field: "name" },
                { title: "性别", field: "sex" },
                { title: "邮箱", field: "email", disabled: true },
                { title: "账号", field: "phone" },
            ],
            currentSelectInfo: {}
        }
    },
    methods: {
        handleSelecetFieldShow(item) {
            this.currentSelectInfo = item

            this.selectFieldDrawer = true
        },
        handleSelectFieldClose() {
            this.selectFieldDrawer = false
        },
        changeSelectField(item) {
            const field = this.selectFieldName == item.field ? '' : item.field
            this.selectFieldName = field
        },
        handleSelectFieldConfirm() {
            if(!this.selectFieldName) return this.$message.error("请选择Excel表头字段")
            this.selectFieldDrawer = false
            this.$emit("submit")
        }
    }
}
</script>
<style lang="scss">
.custom-drawer {
    .custom-drawer-content {
        .el-button {
            padding: 4px 15px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            border-color: rgba(217, 217, 217, 1);
            margin-bottom: 12px;
            position: relative;

            &:hover {
                color: rgba(25, 144, 255, 1);
                border-color: rgba(25, 144, 255, 1);
                background-color: transparent;
                font-weight: 400;
            }

            &.is-disabled {
                border-color: rgba(232, 232, 232, 1);
                background-color: rgba(247, 247, 247, 1);
                color: rgba(153, 153, 153, 1);
            }
        }
        .el-button--default:not(.is-disabled) {
            &:active,
            &.active {
                border-color: rgba(25, 144, 255, 1);
                color: rgba(25, 144, 255, 1);
                background-color: transparent;

                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 24px;
                    height: 24px;
                    background: url("https://download.hecoos.com/enlightv/2024-42/3e7006503a748662e8d30ec0baa13890.png") no-repeat;
                    background-size: 24px 24px;
                    background-position: right bottom;
                }


            }
            &:focus {
                background-color: transparent;
            }
        }
        .el-button+.el-button {
            margin-left: 12px;
        }
    }
}
</style>
